var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4706 2.49937C24.4931 2.71112 24.4815 2.88461 24.4354 3.08336C21.0461 9.38739 17.4972 15.6157 13.9716 21.8519C13.3092 22.6401 12.1692 22.6402 11.5068 21.8509C7.98337 15.6445 4.47668 9.41759 1.06238 3.15074C0.765676 2.11971 1.56918 1.02673 2.59068 1.00035C2.86228 0.99333 3.09048 1.09193 3.49888 1.22789C5.01018 1.73143 6.50388 2.30709 8.00868 2.89C9.51008 3.47156 11.024 4.06007 12.5585 4.58043L12.7167 4.63414L12.8759 4.58238C14.4227 4.0719 15.9442 3.48347 17.452 2.89976C18.9636 2.31464 20.4614 1.73428 21.9784 1.22887C22.05 1.20512 22.1245 1.17785 22.1923 1.15367C22.2623 1.12872 22.328 1.10538 22.3925 1.08434C22.5252 1.04101 22.6275 1.01635 22.706 1.00914L22.8642 1.00231C23.6465 1.01569 24.3803 1.66903 24.4696 2.50035L24.4706 2.49937Z",
    fill: "#0088FF",
    stroke: "#0D5AA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.c82113860f5e16d072b5ba66901987ee.svg";
export { ForwardRef as ReactComponent };